export default __webpack_public_path__ + "static/media/empty_product_merchant.a6039350.png";